import { render, staticRenderFns } from "./move_list_button.vue?vue&type=template&id=cba5b15c&scoped=true&"
import script from "./move_list_button.vue?vue&type=script&lang=js&"
export * from "./move_list_button.vue?vue&type=script&lang=js&"
import style0 from "./move_list_button.vue?vue&type=style&index=0&id=cba5b15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba5b15c",
  null
  
)

export default component.exports